<template>
    <div class="quarter-bank">
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >

            <el-form-item>
                <el-date-picker
                        v-model="weekValue"
                        type="year" placeholder="选择年" @change="selectYear">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-select v-model="formInline.period">
                    <el-option v-for="n in 4" :label="`第${n}季度`" :key="n" :value="n">第{{n}}季度</el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="getOKRList">查询</el-button>
            </el-form-item>

        </el-form>
        <el-scrollbar style="width: 100%">
            <el-table :data="OKRList" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="月份" prop="月份" sortable></el-table-column>
                <el-table-column label="伙伴" prop="伙伴" sortable></el-table-column>
                <el-table-column label="部门" prop="部门" sortable></el-table-column>
                <el-table-column label="负责人" prop="负责人" sortable></el-table-column>
                <el-table-column label="周期" prop="周期" sortable></el-table-column>
                <el-table-column label="红线（描述）" prop="红线(描述)" sortable></el-table-column>
<!--                <el-table-column label="红线数字" prop="红线数字" sortable></el-table-column>-->
<!--                <el-table-column label="红线实际" prop="红线实际" sortable></el-table-column>-->
                <el-table-column label="OKR描述" prop="奖金描述" sortable></el-table-column>
<!--                <el-table-column label="基准数字（目标）" prop="基准数字(目标)" width="150" sortable></el-table-column>-->
<!--                <el-table-column label="实际" prop="实际" sortable></el-table-column>-->
<!--                <el-table-column label="奖金比例(%)" prop="奖金比例(%)" sortable></el-table-column>-->

                <el-table-column label="完成率(%)" prop="完成率(%)" sortable></el-table-column>



<!--                <el-table-column label="奖金值" prop="奖金" sortable></el-table-column>-->

            </el-table>
        </el-scrollbar>
    </div>
</template>

<script>
//导入 HTTP请求方法

    //定义组件
    export default {
        data() {
            return {
                formInline: {
                    currentPage: 1,
                    pageSize: 50,
                    classId:16,
                    year:'',
                    period:1,


                },
                weekValue:new Date(),
                OKRList:[],

            }
        },
        computed:{

        },
        props:['sectionClassId'],
        //挂载时候执行
        mounted() {
            //this.selectMonth(new Date());
            this.selectYear(new Date())
            var currMonth=(new Date().getMonth() + 1);
            this.formInline.period=Math.floor( ( currMonth % 3 == 0 ? ( currMonth / 3 ) : ( currMonth / 3 + 1 ) ) );
            this.getOKRList()
        },
        methods: {
            getOKRList() {

                this.$store.dispatch('getOKRList',{"period":this.formInline.period,"year":this.formInline.year}).then(res=>{
                    this.OKRList = res;
                    console.log(this.OKRList);
                })
            },
            // selectMonth(val){
            //     this.formInline.year = val.getFullYear()
            //     this.formInline.period = val.getMonth()+1
            // },
            selectYear(val){
                this.formInline.year = val.getFullYear()
            },

         },



    }
</script>



// WEBPACK FOOTER //
// src/components/cooperative/okrList.vue